<template>
  <div class="panel-body">
    <div class="">
      セルモンエージェントの各種設定を行うことができます。
      <div class="mr-t-10">
        <fieldset class="border">
          <legend class="border">FBA長期在庫</legend>
          <div class="pd-l-20 pd-r-20">
            <p class="">
              次回のAmazon請求において、FBA長期在庫追加手数料の対象商品がある場合、メールで通知を受け取ります。<br>
              毎月5日、20日時点で対象商品がある場合にのみ通知します。<br>
              プレミアムにご登録済みの方に通知します。※トライアル中の方はご利用になれません。
            </p>
            <div class="border-bottom mr-b-10">
              <span class="text-size-20 text-primary font-bold pd-r-20">
                <i class="fa fa-pencil-square text-size-28" aria-hidden="true"></i>
                Amazon返送納品の提案を通知する
              </span>
              <toggle-button
                v-model="enableNotice"
                :labels="{checked: 'ON', unchecked: 'OFF'}"
                :height=30
                :width=62
                :sync="true"
              />
            </div>
          </div>
        </fieldset>
      </div>
      <div class="mr-t-10">
        <fieldset class="border">
          <legend class="border">FBA納品推奨</legend>
          <div class="pd-l-20 pd-r-20">
            <p class="">
              Amazonへの納品推奨がある場合、メールで通知を受け取ります。<br>
              毎月5日、20日時点で対象商品がある場合にのみ通知します。<br>
              プレミアムにご登録済みの方に通知します。※トライアル中の方はご利用になれません。
            </p>
            <div class="border-bottom mr-b-10">
              <span class="text-size-20 text-primary font-bold pd-r-20">
                <i class="fa fa-pencil-square text-size-28" aria-hidden="true"></i>
                Amazonへの納品推奨を通知する
              </span>
              <toggle-button
                v-model="enableNoticeFbaInbound"
                :labels="{checked: 'ON', unchecked: 'OFF'}"
                :height=30
                :width=62
                :sync="true"
              />
            </div>
          </div>
        </fieldset>
      </div>
      <div class="mr-t-20">
        <fieldset class="border">
          <legend class="border">セルモン出品</legend>
          <div class="pd-l-20 pd-r-20">
            <p class="">
              セルモンへ出品可能な商品がある場合、メールで通知を受け取ります。<br>
              毎月10日、25日時点で対象商品がある場合にのみ通知します。<br>
              プレミアムにご登録済みの方に通知します。※トライアル中の方はご利用になれません。
            </p>
            <div class="border-bottom mr-b-10">
              <span class="text-size-20 text-primary font-bold pd-r-20">
                <i class="fa fa-pencil-square text-size-28" aria-hidden="true"></i>
                セルモンへの出品提案を通知する
              </span>
              <toggle-button
                v-model="enableNoticeSelmon"
                :labels="{checked: 'ON', unchecked: 'OFF'}"
                :height=30
                :width=62
                :sync="true"
              />
            </div>
          </div>
        </fieldset>
      </div>
      <div class="mr-t-20">
        <fieldset class="border">
          <legend class="border">販売機会拡大</legend>
          <div class="pd-l-20 pd-r-20">
            <p class="">
              販売機会拡大のための推奨アクションがある場合、メールで通知を受け取ります。<br>
              毎月5日、20日時点で対象商品がある場合にのみ通知します。<br>
              プレミアムにご登録済みの方に通知します。※トライアル中の方はご利用になれません。
            </p>
            <div class="border-bottom mr-b-10">
              <span class="text-size-20 text-primary font-bold pd-r-20">
                <i class="fa fa-pencil-square text-size-28" aria-hidden="true"></i>
                販売機会拡大の推奨アクションを通知する
              </span>
              <toggle-button
                v-model="enableNoticePromotion"
                :labels="{checked: 'ON', unchecked: 'OFF'}"
                :height=30
                :width=62
                :sync="true"
              />
            </div>
          </div>
        </fieldset>
      </div>
      <div class="text-right mr-t-10">
        <button class="btn btn-warning w-120" @click="handleClickUpdate()" :disabled="disableUpdate">更新</button>
      </div>
    </div>
  </div>
</template>

<script>
import SalemonAgentService from '@/services/salemonagentservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      enableNotice: true,
      enableNoticeFbaInbound: true,
      enableNoticeSelmon: true,
      enableNoticePromotion: true,
      loader: null
    }
  },
  computed: {
    enableAgentNotice () {
      return this.$store.getters.getUser.enableAgentNotice
    },
    enableAgentNoticeFbaInbound () {
      return this.$store.getters.getUser.enableAgentNoticeFbaInbound
    },
    enableAgentNoticeSelmon () {
      return this.$store.getters.getUser.enableAgentNoticeSelmon
    },
    enableAgentNoticePromotion () {
      return this.$store.getters.getUser.enableAgentNoticePromotion
    },
    disableUpdate () {
      return this.enableNotice === this.enableAgentNotice && this.enableNoticeSelmon === this.enableAgentNoticeSelmon && this.enableNoticeFbaInbound === this.enableAgentNoticeFbaInbound && this.enableNoticePromotion === this.enableAgentNoticePromotion
    }
  },
  created () {
    this.enableNotice = this.enableAgentNotice
    this.enableNoticeSelmon = this.enableAgentNoticeSelmon
    this.enableNoticeFbaInbound = this.enableAgentNoticeFbaInbound
    this.enableNoticePromotion = this.enableAgentNoticePromotion
  },
  methods: {
    async handleClickUpdate () {
      let logParams = {
        name: eventCode.settings.agent_notice_tab.click_update,
        properties: { enableNotice: this.enableNotice, enableNoticeFbaInbound: this.enableNoticeFbaInbound, enableNoticeSelmon: this.enableNoticeSelmon }
      }
      EventService.postTrackLog(logParams)
      this.loader = this.$loading.show()
      await SalemonAgentService.updateSettingNotice({ enableNotice: this.enableNotice, enableNoticeSelmon: this.enableNoticeSelmon, enableNoticeFbaInbound: this.enableNoticeFbaInbound })
        .then((response) => {
          this.$store.commit('setEnableAgentNotice', { enableNotice: this.enableNotice, enableNoticeSelmon: this.enableNoticeSelmon, enableNoticeFbaInbound: this.enableNoticeFbaInbound })
          this.$store.commit('toggleModal', {
            show: true,
            message: '更新が完了しました。'
          })
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'agent-notice') {
      let logParams = {
        name: eventCode.settings.agent_notice_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
      setTimeout(() => {
        this.$events.fire('done')
      }, 500)
    }
  },
  watch: {
    enableAgentNotice () {
      this.enableNotice = this.enableAgentNotice
    },
    enableAgentNoticeFbaInbound () {
      this.enableNoticeFbaInbound = this.enableAgentNoticeFbaInbound
    },
    enableAgentNoticeSelmon () {
      this.enableNoticeSelmon = this.enableAgentNoticeSelmon
    },
    enableAgentNoticePromotion () {
      this.enableNoticePromotion = this.enableAgentNoticePromotion
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
.text-primary {
  color: #008cc6;
}
.border-bottom {
  border-bottom: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/view/setting/AgentNotice.vue